import React, { useEffect, useState } from 'react';
import styled from '@emotion/styled';
import { Typography } from '@kep-ui-kit/ui-components';
import { Helmet } from 'react-helmet';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { withErrorHandling } from '@selfserve/react-hocs';
import {
  StyledLogo,
  StyledV2PageWrapper,
  StyledV2LogoRow,
  StyledV2PageBackground,
  StyledV2GlassCard,
  StyledV2MailIllustration,
} from '@selfserve/react-ui';
import { routesPaths } from '@selfserve/react-utils';
import { storage, storageKeys, useStorage } from '@selfserve/react-hooks';

const REDIRECT_COUNTDOWN_START = 5;

const StyledContentArea = styled.div(({ theme }: { theme?: any }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(3),
  alignItems: 'center',
  width: '100%',
  maxWidth: '720px',
  alignSelf: 'center',
}));

const StyledTextBlock = styled.div(({ theme }: { theme?: any }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(1),
  width: '100%',
  wordBreak: 'break-word',
}));

const CheckYourInboxV2Component: React.FC = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [countdown, setCountdown] = useState(REDIRECT_COUNTDOWN_START);
  const [emailHash] = useStorage(storage.LOCAL, storageKeys.EMAIL_HASH);
  const [avatarWizard] = useStorage(storage.LOCAL, storageKeys.AVATAR_WIZARD);

  useEffect(() => {
    const interval = setInterval(() => {
      setCountdown((prev) => {
        if (prev <= 1) {
          clearInterval(interval);
          if (emailHash) {
            const path = routesPaths.PLEASE_WAIT.replace(':id', emailHash as string);
            navigate(avatarWizard ? `${path}?avatar-wizard` : path);
          }
          return prev;
        }
        return prev - 1;
      });
    }, 1000);
    return () => clearInterval(interval);
  }, [emailHash, avatarWizard, navigate]);

  return (
    <>
      <Helmet>
        <title>{t('check-your-inbox-v2.check-your-inbox')}</title>
      </Helmet>
      <StyledV2PageWrapper>
        <StyledV2LogoRow>
          <StyledLogo />
        </StyledV2LogoRow>
        <StyledV2PageBackground centered className="container">
          <StyledV2GlassCard maxWidth="498px">
            <StyledContentArea>
              <StyledV2MailIllustration
                src="assets/check-your-inbox-v2-mail.svg"
              />
              <StyledTextBlock>
                <Typography variant="h1" sx={{ margin: 0, textAlign: 'center' }}>
                  {t('check-your-inbox-v2.check-your-inbox')}
                </Typography>
                <Typography variant="body2" textAlign="center">
                  {t('check-your-inbox-v2.body')}
                </Typography>
                <Typography variant={'body2Highlight' as any} textAlign="center">
                  {t('check-your-inbox-v2.redirecting', { count: countdown })}
                </Typography>
              </StyledTextBlock>
            </StyledContentArea>
          </StyledV2GlassCard>
        </StyledV2PageBackground>
      </StyledV2PageWrapper>
    </>
  );
};

export const CheckYourInboxV2 = withErrorHandling<unknown>(CheckYourInboxV2Component);
